import { useState } from "react";

import { Combobox, DropdownButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { IModifiablePrompt } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/prompts-report/edit-modal/types";

import { TopicOptionLabel, TopicsDropdownWrapper } from "./PromptsTable.styled";

interface ITopicsDropdownProps {
    prompt: IModifiablePrompt;
    allTopics: string[];
    onEdit: (prompt: IModifiablePrompt, topic: string) => void;
}

export const TopicsDropdown = ({ prompt, allTopics, onEdit }: ITopicsDropdownProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const selectedTopic = prompt?.currentTopicName ?? "";

    const onTopicClick = (topic: string): void => {
        setIsOpen(false);
        onEdit(prompt, topic);
    };

    return (
        <TopicsDropdownWrapper>
            <Combobox
                width="200px"
                placement="bottom-start"
                isOpen={isOpen}
                onOpenChange={setIsOpen}
                data-automation="prompts-table-topics-dropdown"
            >
                <Combobox.Trigger>
                    <Flex width="100%">
                        <DropdownButton
                            cssClass="DropdownButton--filtersBarDropdownButton"
                            isOpen={isOpen}
                            hasValue
                        >
                            {selectedTopic}
                        </DropdownButton>
                    </Flex>
                </Combobox.Trigger>
                <Combobox.Content>
                    {allTopics.map((topic: string) => (
                        <Combobox.Option
                            key={topic}
                            id={topic}
                            textValue={topic}
                            isSelected={topic === selectedTopic}
                            onClick={() => onTopicClick(topic)}
                        >
                            <TopicOptionLabel>{topic}</TopicOptionLabel>
                        </Combobox.Option>
                    ))}
                </Combobox.Content>
            </Combobox>
        </TopicsDropdownWrapper>
    );
};
